"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const middleware_1 = require("../../../common/js/apis/helper/middleware");
const Audiences_1 = require("../../../common/js/constants/Audiences");
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
class DownloadsMiddleware {
    post(context) {
        return (0, middleware_1.postWithToken)(context);
    }
    pre(context) {
        return (0, middleware_1.preWithToken)(context, Audiences_1.Audiences.DOWNLOADS, [
            AuthorizationScopes_1.default.DOWNLOADS_READ,
            AuthorizationScopes_1.default.SERVICE_READ,
        ]);
    }
}
exports.default = new DownloadsMiddleware();
